/* ===== OC CHRIS THEME - JavaScript ===== */

// Enter site
function enterSite() {
    document.getElementById('splash').classList.add('hidden');
    document.body.classList.add('site-entered');
    document.body.style.overflow = 'auto';
}

// Mobile menu
function toggleMobileMenu() {
    document.querySelector('.nav-links').classList.toggle('mobile-open');
    document.querySelector('.hamburger').classList.toggle('active');
}

// Close mobile menu on link click
document.querySelectorAll('.nav-links a').forEach(link => {
    link.addEventListener('click', () => {
        document.querySelector('.nav-links').classList.remove('mobile-open');
        if (document.querySelector('.hamburger')) document.querySelector('.hamburger').classList.remove('active');
    });
});

// Active nav on scroll
const sections = document.querySelectorAll('section[id]');
window.addEventListener('scroll', () => {
    const scrollY = window.scrollY + 100;
    sections.forEach(section => {
        const top = section.offsetTop;
        const height = section.offsetHeight;
        const id = section.getAttribute('id');
        const link = document.querySelector('.nav-links a[href="#' + id + '"]');
        if (link) {
            if (scrollY >= top && scrollY < top + height) {
                document.querySelectorAll('.nav-links a').forEach(a => a.classList.remove('active'));
                link.classList.add('active');
            }
        }
    });
});

// Music dropdown
function toggleDropdown(el) {
    const menu = el.nextElementSibling;
    const isOpen = menu.classList.contains('show');
    document.querySelectorAll('.dropdown-menu').forEach(m => m.classList.remove('show'));
    document.querySelectorAll('.music-dropdown').forEach(d => d.classList.remove('open'));
    if (!isOpen) {
        menu.classList.add('show');
        el.classList.add('open');
    }
}

// Close dropdowns on outside click
document.addEventListener('click', (e) => {
    if (!e.target.closest('.music-card-info')) {
        document.querySelectorAll('.dropdown-menu').forEach(m => m.classList.remove('show'));
        document.querySelectorAll('.music-dropdown').forEach(d => d.classList.remove('open'));
    }
});

// Video modal
function openVideo(url) {
    document.getElementById('videoFrame').src = url + '?autoplay=1';
    document.getElementById('videoModal').classList.add('active');
}

function closeVideo() {
    document.getElementById('videoFrame').src = '';
    document.getElementById('videoModal').classList.remove('active');
}

document.getElementById('videoModal').addEventListener('click', (e) => {
    if (e.target === document.getElementById('videoModal')) closeVideo();
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeVideo();
});

// Scroll animations
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
        }
    });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

// Prevent scroll when splash is active
document.body.style.overflow = 'hidden';